import { SiteLayout } from '@/components/site/SiteLayout'
import { PolicyShell, PolicySection } from '@/components/site/PolicyShell'

const UPDATED = '2026-05-25'

export function TermsPage() {
  return (
    <SiteLayout>
      <PolicyShell title="Terms of Use" updated={UPDATED}>
        <PolicySection heading="Agreement">
          <p>
            By accessing or using GeoBorder (the "Service"), you agree to
            these Terms of Use. If you don't agree, please don't use the
            Service.
          </p>
        </PolicySection>

        <PolicySection heading="The Service">
          <p>
            GeoBorder is a free public web application and developer API for
            resolving geographic coordinates to their jurisdictional context.
            It's offered at no cost. We may modify, suspend, or discontinue
            any part of the Service at any time without notice or liability.
          </p>
        </PolicySection>

        <PolicySection heading="Acceptable use">
          <p>You agree to use the Service responsibly. In particular, you agree not to:</p>
          <ul>
            <li>
              Use the Service to violate any law, regulation, or third party's
              rights.
            </li>
            <li>
              Interfere with, abuse, or attempt to circumvent rate limits,
              authentication, or other technical protections.
            </li>
            <li>
              Use automated processes to overwhelm the Service, scrape data
              beyond what the documented endpoints allow, or evade detection
              of such activity.
            </li>
            <li>
              Share, sell, or otherwise distribute your API keys to anyone
              outside your own usage.
            </li>
            <li>
              Misrepresent your identity, impersonate others, or attempt to
              gain access to accounts that aren't yours.
            </li>
          </ul>
          <p>
            We may suspend or terminate access for any user that violates
            these terms, and we may rate-limit, throttle, or revoke API keys
            at our discretion to protect the Service.
          </p>
        </PolicySection>

        <PolicySection heading="Data accuracy">
          <p>
            Boundary data comes from public, openly licensed sources
            (primarily U.S. Census TIGER/Line and Natural Earth) and is
            served as-provided. Geographic data is inherently subject to
            error, lag, and ambiguity. GeoBorder is{' '}
            <strong>
              not authoritative for any legal, regulatory, emergency, or
              navigation purpose
            </strong>
            . If you need an authoritative answer about jurisdiction or
            boundary, consult the relevant government agency.
          </p>
        </PolicySection>

        <PolicySection heading="No warranty">
          <p>
            THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE," WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT
            LIMITED TO WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE, NON-INFRINGEMENT, ACCURACY, OR UNINTERRUPTED
            AVAILABILITY. YOUR USE OF THE SERVICE IS AT YOUR OWN RISK.
          </p>
        </PolicySection>

        <PolicySection heading="Limitation of liability">
          <p>
            TO THE FULLEST EXTENT PERMITTED BY LAW, IN NO EVENT WILL
            GEOBORDER, ITS OPERATORS, OR ITS CONTRIBUTORS BE LIABLE FOR ANY
            INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE
            DAMAGES, OR ANY LOSS OF PROFITS, REVENUE, DATA, OR GOODWILL,
            ARISING OUT OF OR RELATED TO YOUR USE OF THE SERVICE — WHETHER
            BASED ON WARRANTY, CONTRACT, TORT, STATUTE, OR ANY OTHER LEGAL
            THEORY — EVEN IF WE'VE BEEN ADVISED OF THE POSSIBILITY OF SUCH
            DAMAGES. BECAUSE THE SERVICE IS PROVIDED AT NO CHARGE, YOU
            ACKNOWLEDGE THAT THE TOTAL AGGREGATE LIABILITY OF THE OPERATORS
            FOR ANY CLAIM RELATED TO THE SERVICE IS LIMITED TO ZERO U.S.
            DOLLARS.
          </p>
        </PolicySection>

        <PolicySection heading="Indemnity">
          <p>
            You agree to indemnify and hold harmless the operators of the
            Service and any contributors from claims arising out of your
            misuse of the Service or breach of these Terms.
          </p>
        </PolicySection>

        <PolicySection heading="Changes">
          <p>
            We may update these Terms from time to time. The "last updated"
            date at the top reflects the most recent revision. Continued use
            of the Service after changes constitutes acceptance of the
            revised Terms.
          </p>
        </PolicySection>

        <PolicySection heading="Governing law">
          <p>
            These Terms are governed by the laws of the State of Delaware,
            United States, without regard to its conflict-of-laws principles.
            Any disputes arising from these Terms or your use of the Service
            are subject to the exclusive jurisdiction of the federal and
            state courts located in Delaware.
          </p>
        </PolicySection>
      </PolicyShell>
    </SiteLayout>
  )
}
